import React, { useContext, useEffect, useState } from 'react'
import { FaFilePdf, FaFileExcel, FaSpinner } from 'react-icons/fa'
import { Plus } from 'lucide-react';
import { PenLine, ChevronDown, ChevronUp } from 'lucide-react';
import { FormContext } from '../Provider'
import { useNavigate } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion';
import LoadingScreen from '../Loading';


// const courses = ['All Courses', 'Frontend Web Development', 'Backend Web Development', 'Full Stack Development-MERN', 'Data Analytics', 'Artifical Intelligence & Machine Learning',
//     'Data Science', 'HR Analytics', 'Embedded Development', 'Wiring Harness', 'UI & UX Design'];





const AdminDashboard = () => {
    const { Auth, studentsData } = useContext(FormContext);
    const api = process.env.REACT_APP_URL;

    const [courses, setCourses] = useState(null)

    useEffect(() => {
        fetch(`${api}/get-courses`,
            {
                method: 'GET',
                credentials: 'include'
            })
            .then(res => res.json())
            .then((data) => {
                if (data.success) {
                    setCourses(data.courses)
                    console.log(data)
                }
                else {
                    alert(data.message)
                }

            })

    }, [api])
    const navigate = useNavigate();

    const [filter, setFilter] = useState('All Courses');
    const filteredStudents = filter === 'All Courses'
        ? studentsData
        : studentsData.filter(s => s.registration.course === filter);

    // Track selected users by index
    const [selectedRows, setSelectedRows] = useState([]);

    const handleCheckboxChange = (idx) => {
        setSelectedRows(prev =>
            prev.includes(idx)
                ? prev.filter(i => i !== idx)
                : [...prev, idx]
        );
    };

    // Download PDF for each selected user
    const [loading, setLoading] = useState(false)
    const handleDownloadPDF = async () => {
        if (!selectedRows.length) {
            alert('Please select at least one user to download PDF.');
            return;
        }
        for (const idx of selectedRows) {
            const student = filteredStudents[idx];
            setLoading(true)
            try {
                const response = await fetch(`${api}/pdfDownload/${student.id}`, {
                    method: 'GET',
                    credentials: 'include',
                });
                if (!response.ok) throw new Error('PDF download failed');
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${student.personalData.name}_details.pdf`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            } catch (err) {
                console.log('Trouble in Download PDF file', err);
                alert('Trouble in Download PDF file');
            }
            finally {
                setTimeout(() => {
                    setLoading(false);
                }, 2000);
            }
        }
    };

    const handleDownloadExcel = () => {
        fetch(`${api}/downloadExcel`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'students_data.xlsx';
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch(err => {
                console.log('Trouble in Download Excel file', err);
                alert('Trouble in Download Excel file');
            });
    };



    // Add the coursrs details section

    const [showAddCourse, setShowAddCourse] = useState(false);
    const [open, setOpen] = useState(false);
    const [errors, setErrors] = useState({
        courseName: '',
        months: ''
    })
    const [successMessage, setSuccessMessage] = useState('');
    const [courseDetails, setCoursedetails] = useState({
        courseName: '',
        months: ''
    })


    // Edit and update courses
    const [editCourse, setEditCourse] = useState({
        id: '',
        courseTitle: '',
        months: ''
    })

    const [showEdit, setShowEdit] = useState(false)

    const handleSelect = (value) => {
        setFilter(value);
        setOpen(false);
    };

    const handleEdit = (courseId) => {

        setShowEdit(true)
        // Edit Courses
        fetch(`${api}/get-course/${courseId}`,
            {
                method: 'GET',
                credentials: 'include'
            })
            .then(res => res.json())
            .then(data => {

                if (data.success) {
                    setEditCourse(data.course)
                }
            })
            .catch(err => console.log("Error in fetchomg the data", err))

    }
    //edit course 
    const handleCourseUpdate = (id) => {
        fetch(`${api}/update-course/${id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ courseTitle: editCourse.courseTitle, months: editCourse.months }),
        })
            .then(res => res.json())
            .then(data => {

                if (data.success === true) {

                    setSuccessMessage(data.message);
                    setTimeout(() => {
                        setShowEdit(false);
                        setOpen(false)
                        setEditCourse({ courseTitle: '', months: '' });
                        setSuccessMessage('');
                        window.location.reload()
                    }, 1000)

                }
                else {
                    setSuccessMessage(data.message);
                }
            })
            .catch(err => {
                console.log("error in fetch user login", err);
            })


    }



    // new create course
    const handleCourseSubmit = () => {
        const newErrors = {
            courseName: '',
            months: ''
        }

        if (!courseDetails.courseName.trim()) {
            newErrors.courseName = "Enter the Course Name";
        }
        if (!courseDetails.months) {
            newErrors.months = "Enter the Course Duration in Months";
        }

        setErrors(newErrors);

        if (courseDetails.courseName && courseDetails.months) {
            fetch(`${api}/create-course`, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ courseTitle: courseDetails.courseName, months: courseDetails.months }),
            })
                .then(res => res.json())
                .then(data => {

                    if (data.success === true) {

                        setSuccessMessage(data.message);
                        setTimeout(() => {
                            setShowAddCourse(false);
                            setCoursedetails({ courseName: '', months: '' });
                            setSuccessMessage('');
                            window.location.reload()
                        }, 1000)

                    }
                    else {
                        setSuccessMessage(data.message);
                    }
                })
                .catch(err => {
                    console.log("error in fetch user login", err);
                })
        }

    }

    return (

        <div>
            {Auth ? (
                <main className="min-h-screen  p-0">

                    <div className={showAddCourse ? "relative backdrop-blur-2xl pointer-events-none" : ""}>
                        <h1 className="text-3xl font-extrabold text-blue-900 mb-6 px-4 py-8">Admin Dashboard</h1>
                        <section className="w-full bg-white rounded-none  p-4 md:p-8 mx-auto ">
                            <div className=" ">

                                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-4 ">
                                    <div className="relative inline-block w-full md:w-96 ">
                                        <button
                                            onClick={() => setOpen(!open)}
                                            className="w-full border px-4 py-2 rounded-lg bg-white shadow flex justify-between focus:outline-none focus:ring-2 focus:ring-blue-400 text-left text-gray-700"
                                        >
                                            {filter || 'Select a Course'}  {open ? <ChevronUp /> : <ChevronDown />}
                                        </button>

                                        {open && (
                                            <ul className="absolute z-10 mt-1 w-full bg-white border rounded-lg shadow max-h-60 overflow-y-auto">
                                                <li
                                                    className="flex justify-between items-center px-4 py-2 hover:bg-secondary-600  hover:text-white cursor-pointer"
                                                    onClick={() => handleSelect('All Courses')}
                                                >
                                                    <span>All Courses</span>
                                                </li>

                                                {courses.map((course) => (
                                                    <li
                                                        key={course.id}
                                                        className="flex justify-between items-center px-4 py-2 hover:bg-secondary-600  hover:text-white cursor-pointer"
                                                    >
                                                        <span
                                                            onClick={() => handleSelect(course.courseTitle)}
                                                            className="flex-1"
                                                        >
                                                            {course.courseTitle}
                                                        </span>
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation(); // prevent triggering select
                                                                handleEdit(course.id);
                                                            }}
                                                            className="ml-2 p-1 hover:bg-white rounded hover:text-black"
                                                        >
                                                            <PenLine className="w-4 h-4   " />
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>



                                    <div className="flex flex-row sm:flex-row gap-3 w-full sm:w-auto">

                                        <button className="flex items-center justify-center gap-2 bg-primary-300 hover:bg-primary-700 text-white sm:px-4 px-2 py-2 rounded-lg shadow transition w-full sm:w-auto "
                                            onClick={() => {
                                                setShowAddCourse(true)
                                                setShowEdit(false)
                                            }}
                                        >
                                            <Plus />
                                            <span className="inline md:hidden font-medium" >Course</span>
                                            <span className="hidden md:inline font-medium ">Add Courses</span>
                                        </button>



                                        <button className={`flex items-center justify-center gap-2 px-4 py-2 rounded-lg shadow w-full sm:w-auto transition
                                                 ${loading ? 'bg-yellow-400 cursor-wait' : 'bg-red-300 hover:bg-red-600'} text-white`}
                                            onClick={handleDownloadPDF}
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <FaSpinner className="animate-spin" />
                                                    <span>Downloading...</span>
                                                </>
                                            ) : (
                                                <>
                                                    <FaFilePdf />
                                                    <span className="inline md:hidden font-medium">PDF</span>
                                                    <span className="hidden md:inline font-medium">Download PDF</span>
                                                </>
                                            )}
                                        </button>
                                        <button className="flex items-center justify-center gap-2 bg-green-300 hover:bg-green-700 text-white px-4 py-2 rounded-lg shadow transition w-full sm:w-auto"
                                            onClick={handleDownloadExcel}
                                        >
                                            <FaFileExcel />
                                            <span className="inline md:hidden font-medium" >Excel</span>
                                            <span className="hidden md:inline font-medium">Download Excel</span>
                                        </button>
                                    </div>


                                </div>
                            </div>
                            <div className="overflow-x-auto w-full rounded-lg shadow-md">
                                <table className="w-full rounded-lg shadow-sm bg-white">
                                    <thead className="bg-primary-200 text-blue-900 font-semibold text-sm">
                                        <tr>
                                            <th className="px-6 py-3 text-left">Select</th>
                                            <th className="px-6 py-3 text-left">S.No</th>
                                            <th className="px-6 py-3 text-left">Name</th>
                                            <th className="px-6 py-3 text-left">Course Name</th>
                                            <th className="px-6 py-3 text-left">Email</th>
                                            <th className="px-6 py-3 text-left">Phone Number</th>
                                            <th className="px-6 py-3 text-left">Register Date</th>
                                            <th className="px-6 py-3 text-left">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-sm text-gray-700">
                                        {filteredStudents && filteredStudents.length === 0 ? (
                                            <tr>
                                                <td colSpan={7} className="text-center py-6 text-gray-500">No students found.</td>
                                            </tr>
                                        ) : (
                                            filteredStudents && filteredStudents.map((student, idx) => (
                                                <tr key={idx} className="hover:bg-primary-50 transition">
                                                    <td className="py-3 px-4 border-b text-gray-800">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedRows.includes(idx)}
                                                            onChange={() => handleCheckboxChange(idx)}
                                                        />
                                                    </td>
                                                    <td className="py-3 px-4 border-b text-gray-800">{idx + 1}</td>
                                                    <td className="py-3 px-4 border-b text-gray-800">{student.personalData.name}</td>
                                                    <td className="py-3 px-4 border-b text-gray-800">{student.registration.course}</td>
                                                    <td className="py-3 px-4 border-b text-gray-800">{student.personalData.email}</td>
                                                    <td className="py-3 px-4 border-b text-gray-800">{student.personalData.contact}</td>
                                                    <td className="py-3 px-4 border-b text-gray-800">{new Date(student.registration.registerDate).toLocaleDateString()}</td>
                                                    <td className="py-3 px-4 border-b "><i className="bi bi-pencil-square text-blue-600"
                                                        onClick={() => navigate(`/admin-forms/${student.id}`)
                                                        }
                                                    ></i></td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    </div>

                    {/* Add courses Details  */}
                    {
                        showAddCourse && (


                            <AnimatePresence>
                                <motion.div
                                    className="fixed inset-0 z-50 bg-black/40 flex justify-center items-center px-4"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                >
                                    <motion.div
                                        className="bg-white w-full max-w-md p-6 rounded-2xl shadow-2xl relative"
                                        initial={{ y: 50, opacity: 0, scale: 0.95 }}
                                        animate={{ y: 0, opacity: 1, scale: 1 }}
                                        exit={{ y: 50, opacity: 0, scale: 0.95 }}
                                        transition={{ type: "spring", stiffness: 300, damping: 25 }}
                                    >
                                        <h3 className="text-xl sm:text-2xl font-bold text-center text-blue-900 uppercase mb-6">
                                            Add Courses
                                        </h3>

                                        <div className="mb-4">
                                            <label className="block text-sm md:text-lg font-medium text-black mb-3">
                                                Course Name :
                                            </label>
                                            <input
                                                value={courseDetails.courseName}
                                                onChange={(e) => {
                                                    setCoursedetails({ ...courseDetails, courseName: e.target.value })
                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        courseName: '',
                                                    }));
                                                }}
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
                                                placeholder="Enter course name"
                                                required


                                            />
                                            {
                                                errors.courseName && (
                                                    <p className="text-red-500 text-xs mt-1">{errors.courseName}</p>
                                                )
                                            }
                                        </div>

                                        <div className="mb-4">
                                            <label className="block text-sm md:text-lg font-medium text-black mb-3">
                                                Months :
                                            </label>
                                            <input
                                                value={courseDetails.months}
                                                onChange={(e) => {
                                                    if (/^\d{0,2}$/.test(e.target.value))
                                                        setCoursedetails({ ...courseDetails, months: e.target.value })
                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        months: '',
                                                    }));
                                                }
                                                }
                                                type="number"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
                                                placeholder="Enter course duration in months"
                                                inputMode="numeric"      // Mobile: shows numeric keypad
                                                maxLength={2}
                                                required
                                            />
                                            {
                                                errors.months && (
                                                    <p className="text-red-500 text-xs mt-1">{errors.months}</p>
                                                )
                                            }
                                        </div>

                                        {
                                            successMessage && (
                                                <p className="text-green-500 text-sm mb-4">{successMessage}</p>
                                            )
                                        }

                                        <div className="flex justify-end gap-3 pt-4">
                                            <button
                                                onClick={() => setShowAddCourse(false)}
                                                className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 transition text-sm sm:text-base font-bold"
                                            >
                                                Cancel
                                            </button>
                                            <button className="bg-green-600 text-white px-5 py-2 rounded-lg hover:bg-green-700 transition text-sm sm:text-base font-bold"
                                                onClick={handleCourseSubmit}>
                                                Save
                                            </button>
                                        </div>
                                    </motion.div>
                                </motion.div>
                            </AnimatePresence>
                        )
                    }


                    {
                        showEdit && (


                            <AnimatePresence>
                                <motion.div
                                    className="fixed inset-0 z-50 bg-black/40 flex justify-center items-center px-4"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                >
                                    <motion.div
                                        className="bg-white w-full max-w-md p-6 rounded-2xl shadow-2xl relative"
                                        initial={{ y: 50, opacity: 0, scale: 0.95 }}
                                        animate={{ y: 0, opacity: 1, scale: 1 }}
                                        exit={{ y: 50, opacity: 0, scale: 0.95 }}
                                        transition={{ type: "spring", stiffness: 300, damping: 25 }}
                                    >
                                        <h3 className="text-xl sm:text-2xl font-bold text-center text-blue-900 uppercase mb-6">
                                            Update Course Details
                                        </h3>

                                        <div className="mb-4">
                                            <label className="block text-sm md:text-lg font-medium text-black mb-3">
                                                Course Name :
                                            </label>
                                            <input
                                                value={editCourse.courseTitle}
                                                onChange={(e) => setEditCourse({ ...editCourse, courseTitle: e.target.value })}
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
                                                placeholder="Enter course name"
                                                required


                                            />

                                        </div>

                                        <div className="mb-4">
                                            <label className="block text-sm md:text-lg font-medium text-black mb-3">
                                                Months :
                                            </label>
                                            <input
                                                value={editCourse.months}
                                                onChange={(e) => {
                                                    if (/^\d{0,2}$/.test(e.target.value))
                                                        setEditCourse({ ...editCourse, months: e.target.value })
                                                    setErrors({})
                                                }
                                                }
                                                type="number"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
                                                placeholder="Enter course duration in months"
                                                inputMode="numeric"      // Mobile: shows numeric keypad
                                                maxLength={2}
                                                required
                                            />

                                        </div>

                                        {
                                            successMessage && (
                                                <p className="text-green-500 text-sm mb-4">{successMessage}</p>
                                            )
                                        }

                                        <div className="flex justify-end gap-3 pt-4">
                                            <button
                                                onClick={() => {
                                                    setShowAddCourse(false)
                                                    setShowEdit(false)
                                                    setOpen(false)
                                                }}
                                                className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 transition text-sm sm:text-base font-bold"
                                            >
                                                Cancel
                                            </button>
                                            <button className="bg-green-600 text-white px-5 py-2 rounded-lg hover:bg-green-700 transition text-sm sm:text-base font-bold"
                                                onClick={() => handleCourseUpdate(editCourse.id)}>
                                                Update
                                            </button>
                                        </div>
                                    </motion.div>
                                </motion.div>
                            </AnimatePresence>
                        )
                    }




                </main >

            ) :
                <LoadingScreen />}
        </div >
    );
}

export default AdminDashboard;